interface Props {
  className?: string;
}

/** Decorative security/trust panel for the public landing page (not meaningful to assistive tech). */
export function SecurityTrustIllustration({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 360 320"
      width="360"
      height="320"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="sl-trust-shield" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#0d7a8a" />
          <stop offset="100%" stopColor="#065a66" />
        </linearGradient>
        <filter id="sl-trust-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="8" floodColor="#0f2942" floodOpacity="0.12" />
        </filter>
      </defs>
      <rect x="8" y="8" width="344" height="304" rx="20" fill="#f0fafa" stroke="#d8e2ec" strokeWidth="1" />
      {/* Protected data flow */}
      <circle cx="52" cy="88" r="5" fill="#1a6eb5" opacity="0.35" />
      <circle cx="52" cy="128" r="5" fill="#0d7a8a" opacity="0.45" />
      <circle cx="52" cy="168" r="5" fill="#1a6eb5" opacity="0.35" />
      <path
        d="M57 88 C90 88, 95 115, 120 128 C95 141, 90 168, 57 168"
        fill="none"
        stroke="#8fa3b8"
        strokeWidth="1.5"
        strokeDasharray="4 5"
        opacity="0.5"
      />
      {/* Document / secure storage */}
      <g filter="url(#sl-trust-shadow)" transform="translate(248, 52)">
        <rect x="0" y="0" width="72" height="92" rx="10" fill="#fff" stroke="#b8d4e0" strokeWidth="1.5" />
        <rect x="12" y="18" width="48" height="6" rx="3" fill="#e8f2fb" />
        <rect x="12" y="32" width="40" height="5" rx="2.5" fill="#e6f4f6" />
        <rect x="12" y="44" width="44" height="5" rx="2.5" fill="#e6f4f6" />
        <circle cx="56" cy="78" r="14" fill="#ecfdf5" stroke="#0f766e" strokeWidth="1.5" />
        <path
          d="M50 78 L54 82 L62 72"
          fill="none"
          stroke="#0f766e"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      {/* Central shield */}
      <g filter="url(#sl-trust-shadow)" transform="translate(108, 72)">
        <path
          d="M72 8 L132 32 L132 88 C132 124 104 148 72 164 C40 148 12 124 12 88 L12 32 Z"
          fill="url(#sl-trust-shield)"
          stroke="#043840"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <rect x="58" y="62" width="28" height="22" rx="5" fill="#e8f2fb" stroke="#0f2942" strokeWidth="1.5" />
        <path
          d="M72 62 C72 52, 82 48, 88 54 C94 48, 104 52, 104 62 L104 72 L58 72 L58 62 Z"
          fill="none"
          stroke="#0f2942"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle cx="72" cy="73" r="4" fill="#0f2942" />
      </g>
      {/* Role / tenant badges */}
      <g transform="translate(40, 208)">
        <rect x="0" y="0" width="88" height="36" rx="18" fill="#fff" stroke="#d8e2ec" strokeWidth="1" />
        <circle cx="22" cy="18" r="8" fill="#e6f4f6" stroke="#0d7a8a" strokeWidth="1.2" />
        <rect x="36" y="12" width="42" height="5" rx="2.5" fill="#0f2942" opacity="0.85" />
        <rect x="36" y="22" width="32" height="4" rx="2" fill="#5a7189" opacity="0.5" />
      </g>
      <g transform="translate(148, 228)">
        <rect x="0" y="0" width="96" height="36" rx="18" fill="#fff" stroke="#d8e2ec" strokeWidth="1" />
        <rect x="14" y="10" width="16" height="16" rx="4" fill="#e8f2fb" stroke="#1a6eb5" strokeWidth="1.2" />
        <rect x="38" y="12" width="46" height="5" rx="2.5" fill="#0f2942" opacity="0.85" />
        <rect x="38" y="22" width="36" height="4" rx="2" fill="#5a7189" opacity="0.5" />
      </g>
      <g transform="translate(252, 200)">
        <rect x="0" y="0" width="80" height="52" rx="12" fill="#fff" stroke="#b8d4e0" strokeWidth="1" />
        <path d="M16 26 L28 38 L44 18" fill="none" stroke="#0f766e" strokeWidth="2.5" strokeLinecap="round" />
        <rect x="50" y="16" width="22" height="4" rx="2" fill="#e6f4f6" />
        <rect x="50" y="26" width="18" height="4" rx="2" fill="#e6f4f6" />
      </g>
    </svg>
  );
}
